import { createPortal } from "react-dom";

export default function CustomPortal({ children }) {
    return createPortal(children, document.body);
}
